import React from 'react';

import { locale } from '@trqk/utils';
import { GradientProgressBar, IconInfoCircle } from '@trqk/components';
import { useProgressCycle } from '@trqk/hooks';

interface ConfirmWorksLoadingStateProps {
    channelName: Maybe<string>;
}

export const ConfirmWorksLoadingState = ({
    channelName,
}: ConfirmWorksLoadingStateProps): JSX.Element => {
    const { progress } = useProgressCycle({
        delay: 500,
        stepSize: 1,
    });

    const label =
        channelName ??
        locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS.LOADING_STATE.LABEL;

    return (
        <>
            <GradientProgressBar
                progress={progress}
                color="purple-to-aqua"
                height={52}
                inProgressLabel={
                    locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                        .LOADING_STATE.IN_PROGRESS_LABEL
                }
                label={label}
                loadingSpinner={true}
            />
            <div
                className="w-1/2 text-tertiary-400 italic grid mt-6"
                style={{ gridTemplateColumns: '30px auto' }}
            >
                <IconInfoCircle fillColor="primary-500" />
                <div>
                    <p>
                        {
                            locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                                .LOADING_STATE.DESCRIPTION.PART_1
                        }
                    </p>
                    <p className="mt-4">
                        {
                            locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                                .LOADING_STATE.DESCRIPTION.PART_2
                        }
                    </p>
                </div>
            </div>
        </>
    );
};
